angular.module('leanlaw').filter("plural", ["$filter", function ($filter) {
  var numbers = ['no', 'one', 'two', 'three'];
  return function (number, string) {
    if (number !== 1) {
      string = string + "s";
    }
    ;
    if (number < numbers.length) {
      return numbers[number] + " " + string;
    }
    return number + " " + string;
  };
}]).filter("pluralize", ["$filter", function ($filter) {
  return function (string, number) {
    if (number !== 1) {
      string = string + "s";
    }
    ;
    return string;
  };
}]);